import React , { useState , useRef, useEffect } from 'react'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faMinus} from '@fortawesome/free-solid-svg-icons'
import { Button } from 'react-bootstrap';

import Calendar from 'react-calendar';


import { ApiCallGet , ApiCallPost } from '../ApiCall/ApiCall';

import  {FloatingLabel,Form , Row , Col} from 'react-bootstrap';

import 'react-calendar/dist/Calendar.css';





export default function AddClient( {closeClient , clientTitle="Cliente"}) { // Formulario para dar de alta a cliente


    const [value, onChange] = useState(new Date());
    const [showCal,setShowCal] = useState( false ) ;
    const [fNacimiento,setFNacimiento] = useState( "NULL")
    const [fIni,setFIni] = useState( "NULL")
    const [fSit,setFSit] = useState( "NULL")

    const [calActual,setCalActual] = useState( "")

    const [dataCurp,setDataCurp] = useState("") ;
    const [insertId,setInsertId] = useState( 0 ) ;

    const [regimenes,setRegimenes] = useState( [])

    const refRfc = useRef() ;
    const refIdCif = useRef() ;
    const refCurp = useRef() 
    const refNombre = useRef( )
    const refAppPaterno = useRef() ;
    const refApMaterno = useRef() ;
    const refSit = useRef() ; 
    const refEntFed = useRef() ; // Entidad Federativa
    const refMunicipio = useRef() ;
    const refColonia = useRef() ;
    const refTipoVialidad = useRef() ;
    const refNomVialidad = useRef() ;
    const refNumExt = useState() ;
    const refNumInt = useState() ;
    const refCp = useState() ;
    const refCorreo = useState() ;
    const refAl = useState() ;
    const refTelefono = useState() ;
    const refEntreCalla = useState() ;
    const refYcalle = useState() ;

    
    

    const [dataNombre,setDataNombre] = useState( "" ) ;

    const [inputFields, setInputFields] = useState([
        {regimen: ''}
    ])

    const [errMessage,setErrMessage] = useState("") ;



    function getRegimenes()
{
    var arr = [
        <option selected>Seleccione Regimen</option> ,

    ] ;

    for( var i = 0 ; i < regimenes.length ; i++ )
    {

        

        arr.push(<option value={regimenes[i].id}>{regimenes[i].descripcion}</option>)

    }

    return arr ;

}


    function handleRfc()
    {
        if ( refRfc.current.value === 'XAXX010101000')
        {
            document.getElementById( 'sel0' ).value = '616' ;

        }
    }


    function onValidar()
    {

        for( var i = 0 ; i<  inputFields.length  ; i++ )
        {
            console.log( 'sel' + i.toString() )

            var elem = document.getElementById( 'sel' + i.toString()) ;

            console.log( "Value en select " + elem.selectedIndex )
        }

        if( errMessage !== "")
        {
            setErrMessage( "")
        }
        else{
            setErrMessage( "Todo bien ... Felicidades!!!")
        }

        

    

    }



    const handleFormChange = (index, event) => {
        let data = [...inputFields];
        data[index][event.target.name] = event.target.value;
        setInputFields(data);
    }

    const addFields = () => {


        if ( refRfc.current.value === 'XAXX010101000')
        {
            return ;
        }

        let newfield = { regimen : '' }


        setErrMessage( "")
    
        setInputFields([...inputFields, newfield])
    }


    const removeFields = (index) => {

        if( inputFields.length === 1 )
        {
            return ;
        }

        let data = [...inputFields];
        data.splice(index, 1)
        setInputFields(data)
    }


    function handleSubmit()
    {
        var data = {
            rfc : "" ,
            idcif : '' ,
            curp : '' ,
            nombre : '' ,
            appaterno : '' ,
            apmaterno : '' ,
            fnacimiento : '' ,
            fini : '' ,
            sitcontribuyente : '' ,
            fultimocambio : '' ,
            entfed : '' ,
            municipio : '' ,
            colonia : '' ,
            tvialidad : '' ,
            nomvialidad : '' ,
            numext : '' ,
            numint : '' ,
            cp : '' ,
            correo : '' ,
            al : '' ,
            telefono : '' ,
            entrecalle : '' ,
            ycalle : '' ,
            dTimeStamp : getFormatDate( new Date().getTime() )
        }

        data.rfc = ( clientTitle === "Cliente" ? refRfc.current.value : "" )  ;
        data.idcif = refIdCif.current.value ;
        data.curp =  refCurp.current.value  ;
        data.nombre = refNombre.current.value ;
        data.appaterno = refAppPaterno.current.value ;
        data.apmaterno = refApMaterno.current.value ;
        data.fnacimiento = ( fNacimiento === "NULL" ? null : fNacimiento)
        data.fini = ( fIni === "NULL" ? null : fIni) 
        data.sitcontribuyente =  getSelectedText( 'thesit') //refSit.current.value ;
        data.fultimocambio = ( fSit === 'NULL' ? null : fSit )
        data.entfed = refEntFed.current.value ;
        data.municipio = refMunicipio.current.value ;  // colonia , tvialidad
        data.colonia = refColonia.current.value ;
        data.tvialidad = refTipoVialidad.current.value ;
        data.nomvialidad = refNomVialidad.current.value ;
        data.numext = refNumExt.current.value ;
        data.numint = refNumInt.current.value ;
        data.cp = refCp.current.value ;
        data.correo = refCorreo.current.value ;
        data.al = refAl.current.value ;
        data.telefono = refTelefono.current.value ;
        data.entrecalle = refEntreCalla.current.value ;
        data.ycalle = refYcalle.current.value ;

        console.log( "data = " + JSON.stringify(data)) ;


        setInsertId( 0 )

        ApiCallPost("saveclient", data )
        .then( (result) => {
            console.log( "Llegando resultado " , JSON.stringify( result.insertId )) ;

            setInsertId( result.insertId ) ;
        })
        .catch((err) =>{
            console.log( err ) ;
        })
    }


    function getSelectedText(elementId) {
        var elt = document.getElementById(elementId);
        
        if (elt.selectedIndex === -1)
        return null;
        
        return elt.options[elt.selectedIndex].text;
        }
        



    useEffect(() =>{


            console.log( "CURP = " + refCurp.current.value) ;
        
        

    },[dataCurp])


    useEffect(() =>{

        console.log( "Nombre  = " + refNombre.current.value   ) ;

    },[dataNombre])

    useEffect(() => {

        ApiCallGet( "getregimenes")
        .then( ( result) => {

            setRegimenes( result ) ;


        })
        .catch((err) => {
            console.log( err ) ;
        })

    } ,[])


    function onSetShowCal( cal ) // Cal ins indica el elemento calendario
    {

        if ( showCal === true )
        {
            setShowCal( false )

            if ( calActual === "fnacimiento")
            {
                setFNacimiento( "NULL")
                return ;
            }
    
            if ( calActual === "fini")
            {
                setFIni( "NULL")
                return ;
            }

            // fultimocambio
            if ( calActual === "fultimocambio")
            {
                setFSit( "NULL")
                return ;
            }



        }

        setCalActual( cal )
        setShowCal( true )

    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2)  + "-" +
            ("00" + date.getDate()).slice(-2) + "T" +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
    
        return dateStr;
    }
    


    function onChange2( val )
    {
        console.log( val ) ;

        console.log( "calActual = " + calActual )

        setShowCal( false ) ;

        onChange( val ) ;

        if ( calActual === "fnacimiento")
        {

            //document.getElementById( 'fnacimiento').innerHTML = 'Hola'

            setFNacimiento( getFormatDate( val))

            return ;

        }

        if ( calActual === "fini")
        {

            setFIni( getFormatDate( val ))
            return ;

        }

        if ( calActual === "fultimocambio")
        {

            setFSit( getFormatDate( val ))
            return ;

        }


    }

    function onSatClick()
    {
        var rfc = document.getElementById( "rfc").value ;
        var idcif = document.getElementById( "idcif").value ;

        console.log( "rfc = " + rfc + "   idcfi = " + idcif)

        if ( rfc === "" || idcif === "")
        {
            return ; // Avisar que hacen falta parametros
        }

        ApiCallGet( "getsat/?rfc=" + rfc + "&cif=" + idcif )
        .then((response) => {

            console.log( "Llamado con exito = " + response.data )

        })
        .catch((err) => {
            console.log( err )
        })
    }

    function onCloseClient()
    {
        closeClient() ;
    }
// myForm form-2 
//display-label-none

// style={{ top:'15%' , right:'20%' , backgroundColor :'lightgray' , borderRadius:'20px' , width : '800px' ,  position : 'fixed' , zIndex : 200 }}

// float-end
  return (
<div className='box-login ' id="theDiv" style={{zIndex:20}} >


    <div className='d-flex flex-column align-items-center' 
            style={{borderWidth:2 , borderColor :'black' , fontFamily : 'Satoshi-Bold'}}>

        <div>
            <p className='tx-color-purple body-1 mt-2'>Alta de {clientTitle}</p>
        </div>

        <div className='display-label-none  mt-3 w-100' style={{overflowY:'auto' , height:'500px'}}>       


        
            <Form  onSubmit={handleSubmit} style={{color:'black'}}>


                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

 
                                <FloatingLabel
                                controlId="rfc"
                                label="Rfc"
                                className="mb-1 " 
                                >
                                <Form.Control ref={refRfc} onChange={handleRfc} 
                                    type="text" placeholder="Rfc" size='sm' readOnly={clientTitle==="Proveedor" ? true : false } style={{ height: '10px' }} />
                                </FloatingLabel>

             


                    </Col>
                    <Col className='col-4'>


                        <FloatingLabel controlId="idcif" label="idcif" >
                            <Form.Control ref={refIdCif} type="text" placeholder="idcif" size='sm' style={{ height: '10px' }} />
                        </FloatingLabel>

                    
                    </Col>

                    <Col className='col-2 mt-2'>

                        <Button  type="text"  
                                className="form-control" onClick={onSatClick}>SAT</Button>
                    </Col>



                </Row>


                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>
                                        
                        <FloatingLabel
                        controlId="curp"
                        label="Curp"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refCurp} type="text" onChange={ setDataCurp} placeholder="curp" />
                        </FloatingLabel>                            
                              


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="nombre" label="Nombre" >
                            <Form.Control ref={refNombre} type="text" onChange={(val)=>setDataNombre(val)} placeholder="Nombre"  />
                        </FloatingLabel>


                    </Col>



                </Row>

                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="appaterno"
                        label="Apellido Paterno"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refAppPaterno} type="text" placeholder="Apellido Paterno" />
                        </FloatingLabel>


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="apmaterno" label="Apellido Materno" >
                            <Form.Control ref={refApMaterno}  type="text" placeholder="Apellido Materno"  />
                        </FloatingLabel>


                    </Col>



                </Row>


                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    
                    <Col className='col-6'>

                                            
                        <FloatingLabel 
                        controlId="fnacimiento"
                        label="Fecha Nacimiento"
                        className="mb-1 " 
                        >
                        <Form.Control   readOnly 
                            onClick={() => onSetShowCal('fnacimiento')} type="text" value={fNacimiento} placeholder="Fecha Nacimiento" />
                        </FloatingLabel>


                    </Col>
                        
                    <Col className='col-6' title='De click para regresar a NULL'>

                                            
                        <FloatingLabel
                        controlId="fini"
                        label="Fecha Inicio"
                        className="mb-1 " 
                        >
                        <Form.Control readOnly onClick={() => onSetShowCal('fini')} 
                            type="text" value={fIni} placeholder="Fecha Inicio" />
                        </FloatingLabel>


                    </Col>
                    


                </Row>

                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    
                    <Col className='col-6'>

                        <FloatingLabel controlId="sitselect" label="Situación Contribuyente" style={{fontSize:'12px'}}>
                            <Form.Select id='thesit' ref={refSit} aria-label="Default select example" >
                                <option>Seleccionar Situación</option>
                                <option value="1">Activo</option>
                                <option value="2">Reactivado</option>
                                <option value="3">Cancelado</option>
                            </Form.Select>
                        </FloatingLabel>

                    </Col>
                        
                    <Col className='col-6'>

                                            
                        <FloatingLabel
                        controlId="fultimocambio"
                        label="Fecha Ultimo Cambio"
                        className="mb-1 " 
                        >
                        <Form.Control readOnly onClick={() => onSetShowCal('fultimocambio')} 
                            type="text" value={fSit} placeholder="Fecha Ultimo Cambio" />
                        </FloatingLabel>


                    </Col>



                </Row>


                {
                    showCal && (
                        <div style={{marginLeft :'50px' , marginRight :'50px'}}>
                            <Calendar onChange={onChange2}></Calendar>
                        </div>
                        
                    )

                }


                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="entfed"
                        label="Entidad Federativa"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refEntFed} type="text" placeholder="Entidad Federativa" />
                        </FloatingLabel>


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="municipio" label="Municipio" >
                            <Form.Control ref={refMunicipio} type="text" placeholder="Municipio"  />
                        </FloatingLabel>


                    </Col>



                </Row>


                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="colonia"
                        label="Colonia"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refColonia} type="text" placeholder="Colonia" />
                        </FloatingLabel>


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="tipovialidad" label="Tipo Vialidad" >
                            <Form.Control ref={refTipoVialidad} type="text" placeholder="Tipo Vialidad"  />
                        </FloatingLabel>


                    </Col>



                </Row>

                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="nomvialidad"
                        label="Nombre Vialidad"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refNomVialidad} type="text" placeholder="Nombre Vialidad" />
                        </FloatingLabel>


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="numext" label="Número Exterior" >
                            <Form.Control ref={refNumExt} type="text" placeholder="Número Exterior"  />
                        </FloatingLabel>


                    </Col>



                </Row>

                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="numint"
                        label="Número Interior"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refNumInt} type="text" placeholder="Número Interior" />
                        </FloatingLabel>


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="cp" label="Código Postal" >
                            <Form.Control ref = {refCp} type="text" placeholder="Código Postal"  />
                        </FloatingLabel>


                    </Col>



                </Row>

                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="correo"
                        label="Correo"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refCorreo} type="email" placeholder="Correo" />
                        </FloatingLabel>


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="al" label="Administración Local" >
                            <Form.Control ref={refAl} type="text" placeholder="Administración Local"  />
                        </FloatingLabel>


                    </Col>



                </Row>

                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="telefono"
                        label="Teléfono"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refTelefono} type="email" placeholder="Teléfono" />
                        </FloatingLabel>


                    </Col>
                    <Col className='col-6'>


                        <FloatingLabel controlId="entrecalle" label="Entre Calle" >
                            <Form.Control ref={refEntreCalla} title='Opcional' type="text" placeholder="Entre Calle"  />
                        </FloatingLabel>


                    </Col>



                </Row>

                <Row style={{marginLeft:'20px', marginRight:'20px'}}>

                    <Col className='col-6'>

                                        
                        <FloatingLabel
                        controlId="ycalle"
                        label="Y Calle"
                        className="mb-1 " 
                        >
                        <Form.Control ref={refYcalle} title='Opcional' type="text" placeholder="Y Calle" />
                        </FloatingLabel>


                    </Col>



                </Row>






            </Form>


            <div style={{margin:'auto' , padding : '20px' , width : '30%'}}>
                <p className='tx-color-purple body-1 mt-2'>Regimen(s) Fiscal(s)</p>
            </div>

            {inputFields.map((input, index) => {
                    return (
                        <div  key={index} className='d-flex align-items-center'  >
                            <select id={'sel' + index.toString()} style={{ width:'600px',borderRadius:'5px', display:'inline' ,margin:'auto' , marginRight :'20px'}}  >
                                {
                                    getRegimenes() 
                                }
                                {/* <input style={{width:'600px',borderRadius:'5px'}}
                                    name='regimen'
                                    placeholder='Regimen'
                                    value={input.name}
                                    onChange={event => handleFormChange(index, event)}
                                /> */}

                                
                            </select>
                            <button   
                                style={{borderRadius:'5px' , display:'inline'}} onClick={removeFields}>Eliminar</button>
                        </div>
                    )
                    })}


                {
                    errMessage !== "" && (
                        <div style={{margin:'auto' , padding : '20px' , width : '40%' , color :'red'}}>
                            <p >{errMessage}</p>
                        </div>
                    )
                }

                <div style={{margin:'auto' , width:'35%' , padding:'10px'}}>
                    <button style={{borderRadius:'5px'}} onClick={addFields} >Agregar Mas...</button>
                    <button style={{borderRadius:'5px'}} onClick={onValidar} >Validar...</button>

                </div>




            {/* {inputFields.map((input, index) => {
                    return (
                        <div  key={index} >
                            <input style={{width:'600px',borderRadius:'5px'}}
                                name='regimen'
                                placeholder='Regimen'
                                value={input.name}
                                onChange={event => handleFormChange(index, event)}
                            />

                            <button style={{borderRadius:'5px'}} onClick={removeFields}>Eliminar</button>
                        </div>
                    )
                    })}

                <button style={{borderRadius:'5px'}} onClick={addFields} >Agregar Mas...</button> */}

        </div>

        
             <div style={{marginLeft :'20px' , marginRight :'20px', marginTop : '20px'}}>
                                    <Button  onClick={handleSubmit}  
                                className="form-control" >Guardar</Button>

                </div>

                <div className='col-1 pt-3 pe-2' >
                    <FontAwesomeIcon onClick={onCloseClient} title='Agrega Cliente' icon={faMinus}></FontAwesomeIcon>
                </div>

        </div>

       
        
</div>
  )
}
